import React from "react";
import { Accordion } from "react-bootstrap";
import Accordions from "../utils/Accordions";

const HowItsWork = () => {
  return (
    <div id="how-its-work">
      <div className="how pt-5" style={{ overflow: "hidden" }}>
        <div className="container features  pt-5 pb-5">
          <div className="row">
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <h2 className="text-start pb-3">How It Works</h2>
              <p className="text-start pb-4">
                Gain invaluable predictive analytics and actionable insights,
                empowering make.
              </p>
              <a
                target="_blank"
                href="https://docs.pharmatrades.net/user-guide"
              >
                <button className="gradient-btn">
                  Start Trading{" "}
                  <img src="/assets/images/cheveron-right.svg" alt="" />
                </button>
              </a>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-duration="1100"
            >
              <div className="how-glb">
                {/* <img
  className="w-100"
  src="/assets/images/about-cap.svg"
  alt=""
  /> */}
                <model-viewer
                  camera-controls
                  auto-rotate
                  alt="3D Model"
                  src="/assets/Capsule.glb"
                  // style={{ width: "126px", height: "143px" }}
                  onError={() =>
                    console.error(
                      "Failed to load the model. Check the file path or model format."
                    )
                  }
                ></model-viewer>
              </div>
            </div>
            <div>
              <Accordions />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItsWork;
